import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'youtubeCodeScrapper'
})
export class YoutubeCodeScrapperPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    try {
      if (value) {
        const regExp = new RegExp(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
        const code = value.match(regExp);
        return code[1];
      }
    } catch (e) {
      return false;
    }
    return null;
  }

}
